import client from './client'
import { toCamel } from '@/helpers/format'

export default {
  /**
   * 美股诊股
   * @param {*} symbol
   * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-biz-service/wikis/diagnosis/%E7%BE%8E%E8%82%A1%E8%AF%8A%E8%82%A1
   */
  async get (symbol, exchange, name, marketType = 'CN') {
    const res = await client.get('/diagnosis/gmg', { params: { ticker: symbol, exchange, name, marketType } })

    const data = (res && res.data && res.data.data) || {}

    return toCamel(data)
  },
  async getHottest () {
    const res = await client.get('/diagnosis/gmg/hot')
    const data = (res && res.data && res.data.data) || {}
    data.forEach(item => { item.symbol = item.ticker })
    return data
  }
}



// WEBPACK FOOTER //
// ./src/plugins/business-api/diagnosis.js